export const sort = {
  toggleDetails: 'Sortierung',
  sortBy: 'Sortieren nach',
  name: {
    asc: 'Name, aufsteigend',
    desc: 'Name, absteigend',
  },
  price: {
    asc: 'Einzelpreis, aufsteigend',
    desc: 'Einzelpreis, absteigend',
  },
  relevance: 'Relevanz',
  recommended: 'Der Grissemann empfiehlt',
};

export const country = {
  AT: 'Österreich',
};

export const status = {
  loggedIn: 'Ausloggen',
  loggedOut: 'Einloggen',
  cancel: 'Abbrechen',
  select: 'Bitte auswählen',
  save: 'Speichern',
  edit: 'Bearbeiten',
  add: 'Neue Adresse anlegen',
  delete: 'Löschen',
  loading: 'Daten werden geladen',
  yes: 'Ja',
  optional: 'optional',
  rename: 'Umbenennen',
  back: 'Zurück',
  toShop: 'Weiter zum Onlineshop',
  accept: 'Akzeptieren',
};

export const missing = {
  image: 'Kein Bild vorhanden.',
};
